import React, { useRef } from 'react';
import * as THREE from 'three';

import { getSunDirection } from '@graphic/utils';

import { useFrame } from '@react-three/fiber';
import { RENDER_ORDER } from '@graphic/constants';
import { useTimeStore } from '@graphic/stores';

const Sun: React.FC = () => {
  const light = useRef<THREE.DirectionalLight | null>(null);

  useFrame(() => {
    const time = useTimeStore.getState().time;
    const { x, y, z } = getSunDirection(time);

    light.current?.position.set(x, y, z);
  }, RENDER_ORDER.OBJECT);

  return <directionalLight ref={light} color={'#ffffff'} intensity={4} />;
};

export default Sun;
